import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import codeStatisticsService from "../../services/codeStatisticsService";

export const getScannedPlatformsAndCounts = createAsyncThunk(
    "code-scan-statistics/getScannedPlatformsAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getScannedPlatformsAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getTotalBranchCount = createAsyncThunk(
    "code-scan-statistics/getTotalBranchCount",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getTotalBranchCount();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getTotalSeverityCount = createAsyncThunk(
    "code-scan-statistics/getTotalSeverityCount",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getTotalSeverityCount();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getSeverityTypesAndCounts = createAsyncThunk(
    "code-scan-statistics/getSeverityTypesAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getSeverityTypesAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getSeveritiesByScannedCode = createAsyncThunk(
    "code-scan-statistics/getSeveritiesByScannedCode",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getSeveritiesByScannedCode();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getLatestCodeScans = createAsyncThunk(
    "code-scan-statistics/getLatestCodeScans",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getLatestCodeScans();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getSecretKeySeverityLevelsAndCounts = createAsyncThunk(
    "code-scan-statistics/getSecretKeySeverityLevelsAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getSecretKeySeverityLevelsAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getTopCveTypesAndCounts = createAsyncThunk(
    "code-scan-statistics/getTopCveTypesAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getTopCveTypesAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getTopVulnerabilitiesByPackages = createAsyncThunk(
    "code-scan-statistics/getTopVulnerabilitiesByPackages",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getTopVulnerabilitiesByPackages();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getAverageVulnerabilityByScans = createAsyncThunk(
    "code-scan-statistics/getAverageVulnerabilityByScans",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getAverageVulnerabilityByScans();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getSecretKeyCategoriesAndCounts = createAsyncThunk(
    "code-scan-statistics/getSecretKeyCategoriesAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getSecretKeyCategoriesAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

export const getScanStatusAndCounts = createAsyncThunk(
    "code-scan-statistics/getScanStatusAndCounts",
    async (data, {rejectWithValue}) => {
        try {
            return await codeStatisticsService.getScanStatusAndCounts();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    });

const initialState = {
    loading: false,
    errorMessage: null,
    successMessage: null,
    scannedPlatformsAndCounts: null,
    totalBranchCount: null,
    totalSeverityCount: null,
    severityTypesAndCounts: null,
    severitiesByScannedCode: null,
    latestCodeScans: null,
    secretKeySeverityLevelsAndCounts: null,
    cveTypesAndCounts: null,
    topVulnerabilitiesByPackages: null,
    averageVulnerabilityByScans: null,
    secretKeyCategoriesAndCounts: null,
    scanStatusAndCounts: null,
    scannedPlatformsAndCountsLoading: false,
    totalBranchCountLoading: false,
    totalSeverityCountLoading: false,
    severityTypesAndCountsLoading: false,
    severitiesByScannedCodeLoading: false,
    latestCodeScansLoading: false,
    secretKeySeverityLevelsAndCountsLoading: false,
    topCveTypesAndCountsLoading: false,
    topVulnerabilitiesByPackagesLoading: false,
    averageVulnerabilityByScansLoading: false,
    secretKeyCategoriesAndCountsLoading: false,
    scanStatusAndCountsLoading: false
};

export const codeStatisticsSlice = createSlice({
    name: 'codeStatisticsSlice',
    initialState,
    reducers: {
        resetMessages: (state) => {
            state.errorMessage = null;
            state.successMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getScannedPlatformsAndCounts.fulfilled, (state, action) => {
            state.scannedPlatformsAndCounts = action.payload?.data;
            state.scannedPlatformsAndCountsLoading = false;
        });
        builder.addCase(getScannedPlatformsAndCounts.pending, (state, action) => {
            state.scannedPlatformsAndCountsLoading = true;
        });
        builder.addCase(getScannedPlatformsAndCounts.rejected, (state, action) => {
            state.scannedPlatformsAndCountsLoading = false;
        });
        builder.addCase(getTotalBranchCount.fulfilled, (state, action) => {
            state.totalBranchCount = action.payload?.data;
            state.totalBranchCountLoading = false;
        });
        builder.addCase(getTotalBranchCount.pending, (state, action) => {
            state.totalBranchCountLoading = true;
        });
        builder.addCase(getTotalBranchCount.rejected, (state, action) => {
            state.totalBranchCountLoading = false;
        });
        builder.addCase(getTotalSeverityCount.fulfilled, (state, action) => {
            state.totalSeverityCount = action.payload?.data;
            state.totalSeverityCountLoading = false;
        });
        builder.addCase(getTotalSeverityCount.pending, (state, action) => {
            state.totalSeverityCountLoading = true;
        });
        builder.addCase(getTotalSeverityCount.rejected, (state, action) => {
            state.totalSeverityCountLoading = false;
        });
        builder.addCase(getSeverityTypesAndCounts.fulfilled, (state, action) => {
            state.severityTypesAndCounts = action.payload?.data;
            state.severityTypesAndCountsLoading = false;
        });
        builder.addCase(getSeverityTypesAndCounts.pending, (state, action) => {
            state.severityTypesAndCountsLoading = true;
        });
        builder.addCase(getSeverityTypesAndCounts.rejected, (state, action) => {
            state.severityTypesAndCountsLoading = false;
        });
        builder.addCase(getSeveritiesByScannedCode.fulfilled, (state, action) => {
            state.severitiesByScannedCode = action.payload?.data;
            state.severitiesByScannedCodeLoading = false;
        });
        builder.addCase(getSeveritiesByScannedCode.pending, (state, action) => {
            state.severitiesByScannedCodeLoading = true;
        });
        builder.addCase(getSeveritiesByScannedCode.rejected, (state, action) => {
            state.severitiesByScannedCodeLoading = false;
        });
        builder.addCase(getLatestCodeScans.fulfilled, (state, action) => {
            state.latestCodeScans = action.payload?.data?.content;
            state.latestCodeScansLoading = false;
        });
        builder.addCase(getLatestCodeScans.pending, (state, action) => {
            state.latestCodeScansLoading = true;
        });
        builder.addCase(getLatestCodeScans.rejected, (state, action) => {
            state.latestCodeScansLoading = false;
        });
        builder.addCase(getSecretKeySeverityLevelsAndCounts.fulfilled, (state, action) => {
            state.secretKeySeverityLevelsAndCounts = action.payload?.data;
            state.secretKeySeverityLevelsAndCountsLoading = false;
        });
        builder.addCase(getSecretKeySeverityLevelsAndCounts.pending, (state, action) => {
            state.secretKeySeverityLevelsAndCountsLoading = true;
        });
        builder.addCase(getSecretKeySeverityLevelsAndCounts.rejected, (state, action) => {
            state.secretKeySeverityLevelsAndCountsLoading = false;
        });
        builder.addCase(getTopCveTypesAndCounts.fulfilled, (state, action) => {
            state.cveTypesAndCounts = action.payload?.data;
            state.topCveTypesAndCountsLoading = false;
        });
        builder.addCase(getTopCveTypesAndCounts.pending, (state, action) => {
            state.topCveTypesAndCountsLoading = true;
        });
        builder.addCase(getTopCveTypesAndCounts.rejected, (state, action) => {
            state.topCveTypesAndCountsLoading = false;
        });
        builder.addCase(getTopVulnerabilitiesByPackages.fulfilled, (state, action) => {
            state.topVulnerabilitiesByPackages = action.payload?.data;
            state.topVulnerabilitiesByPackagesLoading = false;
        });
        builder.addCase(getTopVulnerabilitiesByPackages.pending, (state, action) => {
            state.topVulnerabilitiesByPackagesLoading = true;
        });
        builder.addCase(getTopVulnerabilitiesByPackages.rejected, (state, action) => {
            state.topVulnerabilitiesByPackagesLoading = false;
        });
        builder.addCase(getAverageVulnerabilityByScans.fulfilled, (state, action) => {
            state.averageVulnerabilityByScans = action.payload?.data;
            state.averageVulnerabilityByScansLoading = false;
        });
        builder.addCase(getAverageVulnerabilityByScans.pending, (state, action) => {
            state.averageVulnerabilityByScansLoading = true;
        });
        builder.addCase(getAverageVulnerabilityByScans.rejected, (state, action) => {
            state.averageVulnerabilityByScansLoading = false;
        });
        builder.addCase(getSecretKeyCategoriesAndCounts.fulfilled, (state, action) => {
            state.secretKeyCategoriesAndCounts = action.payload?.data;
            state.secretKeyCategoriesAndCountsLoading = false;
        });
        builder.addCase(getSecretKeyCategoriesAndCounts.pending, (state, action) => {
            state.secretKeyCategoriesAndCountsLoading = true;
        });
        builder.addCase(getSecretKeyCategoriesAndCounts.rejected, (state, action) => {
            state.secretKeyCategoriesAndCountsLoading = false;
        });
        builder.addCase(getScanStatusAndCounts.fulfilled, (state, action) => {
            state.scanStatusAndCounts = action.payload?.data;
            state.scanStatusAndCountsLoading = false;
        });
        builder.addCase(getScanStatusAndCounts.pending, (state, action) => {
            state.scanStatusAndCountsLoading = true;
        });
        builder.addCase(getScanStatusAndCounts.rejected, (state, action) => {
            state.scanStatusAndCountsLoading = false;
        });
    }
});

export const {
    resetMessages
} = codeStatisticsSlice.actions;

export default codeStatisticsSlice.reducer;

